import {
	ALL_DOCUMENT_OPTIONS,
	FileTypeEnum,
	FileTypeLabelEnum,
} from '@/constant';
import { TGetDocumentListByPageResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatDefineDocumentAreaDetail = (
	input: TGetDocumentListByPageResponse['content'][number]
) => {
	return {
		...input,
		typeName:
			input.type === FileTypeEnum.UPLOAD
				? FileTypeLabelEnum.UPLOAD
				: FileTypeLabelEnum.FORM,
		documentTypeName: ALL_DOCUMENT_OPTIONS.find(
			(item) => item.value === input.documentType
		)?.label,
		registDt: formatDate(input.registDt),
		registDtNumber: input.registDt,
	};
};

export const formatDefineDocumentAreaList = (
	input: TGetDocumentListByPageResponse['content']
) => {
	return map(input, formatDefineDocumentAreaDetail);
};
